<app-select
    [(ngModel)]="value"
    [label]="label"
    [options]="options"
    [id]="id"
></app-select>